import React from "react";
import { useAuth } from "../contexts/AuthContext";
import { CAPACIDAD_POR_RUTA, RUTAS_CON_SOFI } from "./AppLayout";
import { usePlanActual } from "../lib/planes";
import SinAcceso from "./SinAcceso";

// ═══════════════════════════════════════════════════════════════════════════════
// EL GUARDIA DE RUTA (COL.12) — la misma regla del menú, leída del mismo sitio
//
// 🔴 POR QUÉ EN LA RUTA Y NO EN CADA PANTALLA. El defecto era que la pantalla se montaba,
//    pedía sus datos, recibía 403 y pintaba «No se pudo cargar…». Aquí no llega a pedir
//    nada: si la sesión ya sabe que no tienes la capacidad, se dice y punto. Un sitio
//    cubre las 14 pantallas con capacidad, en vez de catorce parches que envejecen por
//    separado.
//
// 🔴 LA CAPACIDAD SE DERIVA DE `nav[]`, no se escribe aquí. `CAPACIDAD_POR_RUTA` sale del
//    mismo arreglo que pinta el menú, así que esconder la entrada y cerrar la pantalla no
//    pueden discrepar: es imposible arreglar una y olvidar la otra.
//
// ⚠️ ESTO NO ES LA PROTECCIÓN. El servidor rechaza en tres capas (COL.9) y lo sigue
//    haciendo; un frontend manipulado gana un 403, no acceso. Lo que esto evita es que el
//    panel invite a chocar contra una puerta cerrada y luego llame avería al choque
//    (DT.71).
//
// ⚠️ Y por eso NO sustituye al manejo del 403 en la pantalla: si la sesión dice que sí y
//    el servidor dice que no —capacidad revocada mientras la pestaña seguía abierta—, el
//    guardia deja pasar y la respuesta llega igual. Para eso está `faltaDeAcceso()` en
//    `lib/acceso.js`. Son las dos mitades del mismo problema y hacen falta las dos.
// ═══════════════════════════════════════════════════════════════════════════════

export default function ExigeCapacidad({ ruta, cap, children }) {
  const { puede } = useAuth();
  const capacidad = cap || CAPACIDAD_POR_RUTA[ruta];
  const planActual = usePlanActual();

  // TEN.4 -- la misma regla del menú, por PLAN: una sección de Sofi en un plan sin Sofi no se
  // monta (no pide datos que no existen). Sin invitación a contratar: ésa vive en UN sitio,
  // la tarjeta del Dashboard (decisión de Jesús).
  if (RUTAS_CON_SOFI.has(ruta) && planActual.sinSofi) {
    return (
      <div className="p-8 max-w-xl" data-testid="sin-sofi">
        <h1 className="font-display text-xl font-bold text-slate-900">Esta sección no está en tu plan</h1>
        <p className="text-sm text-slate-600 mt-2">Tu plan no incluye a Sofi ni WhatsApp.</p>
      </div>
    );
  }

  // Una ruta sin capacidad declarada NO se bloquea: significa que basta la sesión (es el
  // caso de /app/perfil). Bloquear por omisión aquí dejaría pantallas inalcanzables sin
  // que nadie lo hubiera decidido.
  if (!capacidad) return children;

  return puede(capacidad) ? children : <SinAcceso capacidad={capacidad} />;
}
